import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Search, Menu, X, Play } from 'lucide-react'
import { SearchModal } from './SearchModal'
import { useUser } from '@/hooks/useUser'

export function Navbar() {
  const { user, clearUser } = useUser()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  const handleSignOut = () => {
    clearUser()
    window.location.reload()
  }

  return (
    <>
      <nav className="bg-dark-300/95 backdrop-blur-md border-b border-gray-800 sticky top-0 z-40">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2 group">
              <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-2 rounded-lg group-hover:shadow-lg transition-shadow">
                <Play className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
                AnimeTine
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className="text-gray-300 hover:text-white transition-colors font-medium"
              >
                Home
              </Link>
              <Link
                to="/browse"
                className="text-gray-300 hover:text-white transition-colors font-medium"
              >
                Browse
              </Link>
              <Link
                to="/genres"
                className="text-gray-300 hover:text-white transition-colors font-medium"
              >
                Genres
              </Link>
              <Link
                to="/top-anime"
                className="text-gray-300 hover:text-white transition-colors font-medium"
              >
                Top Anime
              </Link>
            </div>

            {/* Right Section */}
            <div className="flex items-center space-x-4">
              {/* Search Button */}
              <button
                onClick={() => setIsSearchOpen(true)}
                className="p-2 text-gray-400 hover:text-white transition-colors rounded-lg hover:bg-gray-800"
                aria-label="Search anime"
              >
                <Search className="w-5 h-5" />
              </button>

              {/* User Greeting */}
              {user && (
                <div className="hidden md:flex items-center space-x-2 text-white font-medium">
                  <span className="text-2xl">{user.avatar}</span>
                  <span>Hi, {user.name}</span>
                  <button
                    onClick={handleSignOut}
                    className="ml-2 text-xs text-gray-400 hover:text-white transition-colors"
                    title="Change user"
                  >
                    (Change)
                  </button>
                </div>
              )}

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden p-2 text-gray-400 hover:text-white transition-colors"
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-800">
              <div className="flex flex-col space-y-4">
                {/* Mobile User Greeting */}
                {user && (
                  <div className="flex items-center justify-between text-white font-medium pb-2 border-b border-gray-700">
                    <div className="flex items-center space-x-2">
                      <span className="text-2xl">{user.avatar}</span>
                      <span>Hi, {user.name}</span>
                    </div>
                    <button
                      onClick={handleSignOut}
                      className="text-xs text-gray-400 hover:text-white transition-colors"
                      title="Change user"
                    >
                      Change
                    </button>
                  </div>
                )}
                
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
                <Link
                  to="/browse"
                  className="text-gray-300 hover:text-white transition-colors font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Browse
                </Link>
                <Link
                  to="/genres"
                  className="text-gray-300 hover:text-white transition-colors font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Genres
                </Link>
                <Link
                  to="/top-anime"
                  className="text-gray-300 hover:text-white transition-colors font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Top Anime
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Search Modal */}
      <SearchModal isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  )
}
